var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortfolioLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10 3C8.89543 3 8 3.89543 8 5H7C4.23858 5 2 7.23858 2 10V16C2 18.7614 4.23858 21 7 21H17C19.7614 21 22 18.7614 22 16V10C22 7.23858 19.7614 5 17 5H16C16 3.89543 15.1046 3 14 3H10Z",
    fill: "#8C56E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72139 5C4.11384 5 2 7.11384 2 9.72139C2 10.4936 2.47016 11.1881 3.18716 11.4749L11.0713 14.6285C11.0253 14.7434 11 14.8687 11 15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15C13 14.8687 12.9747 14.7434 12.9287 14.6285L20.8128 11.4749C21.5298 11.1881 22 10.4936 22 9.72139C22 7.11384 19.8862 5 17.2786 5H6.72139Z",
    fill: "#8C56E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioLogo);
export default __webpack_public_path__ + "static/media/portfolio_logo.45846fffdf255e0e5f89549ee1ca0b90.svg";
export { ForwardRef as ReactComponent };